import React, { useEffect, useState } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { Container, Row, Col, Spinner, Alert, Button } from "react-bootstrap"
import InvitationResponse from "../../components/InvitationResponse"

const InvitationPage = () => {
  const { token } = useParams()
  const navigate = useNavigate()
  const { isLoggedIn } = useSelector((state) => state.auth)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  useEffect(() => {
    if (!token) {
      setError("Token de invitación inválido")
      setLoading(false)
      return
    }

    setLoading(false)
  }, [token])

  if (loading) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ height: "calc(100vh - 200px)" }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    )
  }

  if (error) {
    return (
      <Container className="mt-5">
        <Row>
          <Col md={{ span: 8, offset: 2 }}>
            <Alert variant="danger">{error}</Alert>
            <Button onClick={() => navigate("/")} className="mt-3">
              Volver a Inicio
            </Button>
          </Col>
        </Row>
      </Container>
    )
  }

  if (!isLoggedIn) {
    return (
      <Container className="mt-5">
        <Row>
          <Col md={{ span: 8, offset: 2 }}>
            <div className="text-center mb-5">
              <h1>Has sido invitado a CEAEmociones</h1>
              <p className="text-muted mt-3">Para responder a esta invitación, necesitas estar logueado.</p>
            </div>

            <div className="d-grid gap-3 mb-5">
              <Button
                variant="primary"
                size="lg"
                onClick={() => navigate(`/login?invitation=${token}`)}
              >
                Iniciar Sesión
              </Button>
              <Button
                variant="outline-primary"
                size="lg"
                onClick={() => navigate(`/register?invitation=${token}`)}
              >
                Crear Cuenta
              </Button>
            </div>

            <hr className="my-5" />

            <div className="rejection-section text-center">
              <h3>¿Deseas rechazar esta invitación?</h3>
              <p className="text-muted">Si no deseas participar, puedes rechazarla directamente.</p>
              <Button
                variant="danger"
                onClick={() => navigate(`/invitation/reject/${token}`)}
                className="mt-3"
              >
                Rechazar Invitación
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    )
  }

  // Usuario autenticado
  return (
    <Container className="mt-5">
      <Row>
        <Col md={{ span: 8, offset: 2 }}>
          <div className="text-center mb-5">
            <h1>Responder a Invitación</h1>
          </div>
          {token && <InvitationResponse token={token} />}
        </Col>
      </Row>
    </Container>
  )
}

export default InvitationPage
